import { P, match } from "ts-pattern";
import {
  ImageControlValueFormat
} from "../../../controls";
import { useFile } from "../hooks/makeswift-api";
function useImageControlValue(data, definition) {
  const format = definition.config.format ?? ImageControlValueFormat.URL;
  const fileId = match(data).with(P.string, (id) => id).with({ type: "makeswift-file" }, ({ id }) => id).otherwise(() => null);
  const file = useFile(fileId);
  return match([file, data, format]).with([{ __typename: "File" }, P.any, ImageControlValueFormat.URL], ([file2]) => file2.publicUrl).with(
    [
      { __typename: "File", dimensions: P.not(P.nullish) },
      P.any,
      ImageControlValueFormat.WithDimensions
    ],
    ([file2]) => ({
      url: file2.publicUrl,
      dimensions: file2.dimensions
    })
  ).with([P.any, { type: "external-file" }, ImageControlValueFormat.URL], ([, d]) => d.url).with(
    [
      P.any,
      { type: "external-file", width: P.number, height: P.number },
      ImageControlValueFormat.WithDimensions
    ],
    ([, d]) => ({
      url: d.url,
      dimensions: { width: d.width, height: d.height }
    })
  ).otherwise(() => void 0);
}
export {
  useImageControlValue
};
//# sourceMappingURL=image.js.map